import { useEffect, useRef } from 'react';
import './fx-base.css';
import './fx-ui.css';
import './fx-hero.css';
import './fx-work.css';
import './fx-contact.css';
import { Hero, About, Experience, Skills } from './FxSections';
import Projects from './FxProjects';
import { Nav, Contact, Footer, NAV_ITEMS } from './FxChrome';
import {
    usePrefersReducedMotion,
    useRevealOnScroll,
    useActiveSection,
    useScrollProgress,
} from './fxHooks';

const SECTION_IDS = ['home', ...NAV_ITEMS.map((item) => item.id)];

function useCursorGlow(ref, enabled) {
    useEffect(() => {
        const glow = ref.current;
        const finePointer = globalThis.matchMedia?.('(pointer: fine)').matches;
        if (!glow || !enabled || !finePointer) {
            return undefined;
        }
        const onMove = (event) => {
            glow.style.setProperty('--x', `${event.clientX}px`);
            glow.style.setProperty('--y', `${event.clientY}px`);
            glow.classList.add('is-active');
        };
        globalThis.addEventListener('pointermove', onMove, { passive: true });
        return () => globalThis.removeEventListener('pointermove', onMove);
    }, [ref, enabled]);
}

export default function FxPortfolio() {
    const reducedMotion = usePrefersReducedMotion();
    const active = useActiveSection(SECTION_IDS);
    const progress = useScrollProgress();
    const glowRef = useRef(null);

    useRevealOnScroll();
    useCursorGlow(glowRef, !reducedMotion);

    return (
        <div className="fx-app">
            <a className="fx-skip-link" href="#main">Skip to content</a>
            <div className="fx-bg" aria-hidden="true">
                <div className="fx-bg__grid" />
                <div className="fx-bg__orb fx-bg__orb--one" />
                <div className="fx-bg__orb fx-bg__orb--two" />
                <div className="fx-bg__noise" />
            </div>
            <div ref={glowRef} className="fx-cursor-glow" aria-hidden="true" />
            <Nav active={active} progress={progress} />
            <main id="main" tabIndex={-1}>
                <Hero reducedMotion={reducedMotion} />
                <About />
                <Experience />
                <Skills />
                <Projects />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
